import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  padding: 8px 0;
`;

export const Button = styled.button<{ $isActive: boolean }>`
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  border: 1px solid ${({ $isActive }) => ($isActive ? '#F78E1E' : '#d16d0f')};
  background-color: ${({ $isActive }) => ($isActive ? '#F78E1E' : 'transparent')};
  color: ${({ $isActive }) => ($isActive ? '#fff' : '#000')};
  font-size: 0.75rem;
  font-weight: ${({ $isActive }) => ($isActive ? '700' : '500')};
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${({ $isActive }) => ($isActive ? '#e67e22' : '#fff3e6')};
    border-color: ${({ $isActive }) => ($isActive ? '#e67e22' : '#F78E1E')};
  }

  &:active {
    transform: scale(0.95);
  }
`;
